module.exports = __webpack_public_path__ + "img/logo.e0433a5e.svg";